import AlertIcon from './alert.svg';
import AlertInfoIcon from './alert-info.svg';
import AlertTriangleIcon from './alert-triangle.svg';
import ApproveCheckIcon from './approve.svg';
import ArrowDiagonal from './arrow-diagonal.svg';
import ArrowFatShareIcon from './arrow-fatshare.svg';
import ArrowLeftIcon from './arrow-left.svg';
import ArrowRightIcon from './arrow-right.svg';
import AttachmentIcon from './attachment.svg';
import BasketBall from './basket-ball.svg';
import BeerIcon from './beer.svg';
import BeerBadIcon from './beer-bad.svg';
import BeerBallonIcon from './beer-ballon.svg';
import BeerDriveIcon from './beer-drive.svg';
import BeerHeartIcon from './beer-heart.svg';
import BeerMindIcon from './beer-mind.svg';
import BeerSmile from './beer-smile.svg';
import BeerTag from './beer-tag.svg';
import BeersIcon from './beers.svg';
import Building from './building.svg';
import Canvas from './canvas.svg';
import CapsuleIcon from './capsule.svg';
import CaretDownIcon from './caret-down.svg';
import CaretUpIcon from './caret-up.svg';
import ChatIcon from './chat.svg';
import ChatTextIcon from './chat-text.svg';
import CheckIcon from './check.svg';
import CheckMarkIcon from './check-mark.svg';
import ChevronDown from './chevron-down.svg';
import ChevronLeftIcon from './chevron-left.svg';
import ChevronRightIcon from './chevron-right.svg';
import CloseIcon from './close.svg';
import CupsIcon from './cups.svg';
import DiagonalArrowIcon from './diagonal-arrow.svg';
import DiscussionIcon from './discussion.svg';
import DiskIcon from './disk.svg';
import DownloadIcon from './download.svg';
import DraftIcon from './draft.svg';
import EarMarkFillIcon from './ear-mark-fill.svg';
import EditIcon from './edit.svg';
import eighteenPlus from './eighteen-plus.svg';
import Ellipsis from './ellipsis.svg';
import EmailIcon from './email.svg';
import EnvelopeIcon from './envelope.svg';
import ExpandArrowIcon from './expand_arrow.svg';
import ExpandDiagonalIcon from './expand_diagonal.svg';
import ExpandScreenIcon from './expand_screen.svg';
import FilePlusIcon from './file-plus.svg';
import FileZipIcon from './file-zip.svg';
import FilterCircleIcon from './filter-circle.svg';
import FilterCircleFillIcon from './filter-circle-fill.svg';
import FistIcon from './fist.svg';
import Folder from './folder.svg';
import FullScreenActiveIcon from './full-screen-active.svg';
import GenderAmbiguousIcon from './gender-ambiguous.svg';
import GlobeIcon from './globe.svg';
import HandShakeIcon from './hand-shake.svg';
import HelpCenterIcon from './help-center.svg';
import HouseIcon from './house.svg';
import LightbulbIcon from './lightbulb.svg';
import MoutsFourDotsIcon from './mouts-four-dots.svg';
import NewsPaperIcon from './newspaper.svg';
import NewXlIcon from './newxl.svg';
import NixEighteen from './nix-eighteen.svg';
import PencilSquareIcon from './pencil-square.svg';
import PersonCircleIcon from './person-circle.svg';
import PinMapIcon from './pin-map.svg';
import PlusIcon from './plus.svg';
import PoliciesIcon from './policies.svg';
import PregnantWomanIcon from './pregnant-woman.svg';
import RecycleIcon from './recycle.svg';
import RejectIcon from './reject.svg';
import RejectXIcon from './reject-x.svg';
import ScheduleIcon from './schedule.svg';
import SearchIcon from './search.svg';
import SettingsIcon from './settings.svg';
import SignOutIcon from './sign-out.svg';
import SimpleGlobeIcon from './simple-globe.svg';
import SortByIcon from './sort-by.svg';
import StealIcon from './steal.svg';
import TicketIcon from './ticket.svg';
import TicketApprovalIcon from './ticket-approval.svg';
import TranslateIcon from './translate.svg';
import TrashIcon from './trash-bin.svg';
import TrashCircleIcon from './trash-circle.svg';
import UiChecklistIcon from './ui-checklist.svg';
import UniversityIcon from './university.svg';
import UserIcon from './user.svg';
import UsersIcon from './users.svg';
import Vector from './vector.svg';
import WalletCaseIcon from './wallet-case.svg';
import WarningIcon from './warning.svg';
import WhiteCheck from './white-check.svg';
import WhiteFlag from './white-flag.svg';
import XIcon from './x.svg';
import XCircleIcon from './x-circle.svg';
import Zoo from './zoo.svg';

export const icons = {
  NewXl: NewXlIcon,
  translate: TranslateIcon,
  moutsFourDots: MoutsFourDotsIcon,
  caretDown: CaretDownIcon,
  caretUp: CaretUpIcon,
  walletCase: WalletCaseIcon,
  globe: GlobeIcon,
  search: SearchIcon,
  filterCircle: FilterCircleIcon,
  filterCircleFill: FilterCircleFillIcon,
  fullScreenActive: FullScreenActiveIcon,
  house: HouseIcon,
  handShake: HandShakeIcon,
  fileZip: FileZipIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  close: CloseIcon,
  alert: AlertIcon,
  ticket: TicketIcon,
  check: CheckIcon,
  checkMark: CheckMarkIcon,
  helpCenter: HelpCenterIcon,
  policies: PoliciesIcon,
  arrowFatShare: ArrowFatShareIcon,
  discussion: DiscussionIcon,
  envelope: EnvelopeIcon,
  pinMap: PinMapIcon,
  user: UserIcon,
  lightBulb: LightbulbIcon,
  users: UsersIcon,
  signOut: SignOutIcon,
  uiChecklist: UiChecklistIcon,
  ticketApproval: TicketApprovalIcon,
  x: XIcon,
  schedule: ScheduleIcon,
  reject: RejectIcon,
  arrowRight: ArrowRightIcon,
  alertTriangle: AlertTriangleIcon,
  arrowLeft: ArrowLeftIcon,
  trash: TrashIcon,
  folder: Folder,
  xCircle: XCircleIcon,
  vector: Vector,
  rejectX: RejectXIcon,
  approveCheck: ApproveCheckIcon,
  filePlus: FilePlusIcon,
  ellipsis: Ellipsis,
  chevronDown: ChevronDown,
  chat: ChatIcon,
  arrowDiagonal: ArrowDiagonal,
  whiteFlag: WhiteFlag,
  whiteCheck: WhiteCheck,
  pregnantWoman: PregnantWomanIcon,
  beers: BeersIcon,
  beer: BeerIcon,
  cups: CupsIcon,
  beerBallon: BeerBallonIcon,
  beerMind: BeerMindIcon,
  beerSmile: BeerSmile,
  beerBad: BeerBadIcon,
  beerHeart: BeerHeartIcon,
  beerDrive: BeerDriveIcon,
  university: UniversityIcon,
  capsule: CapsuleIcon,
  genderAmbiguous: GenderAmbiguousIcon,
  fist: FistIcon,
  steal: StealIcon,
  newsPaper: NewsPaperIcon,
  chatText: ChatTextIcon,
  recycle: RecycleIcon,
  personCircle: PersonCircleIcon,
  sortBy: SortByIcon,
  plus: PlusIcon,
  simpleGlobe: SimpleGlobeIcon,
  warning: WarningIcon,
  disk: DiskIcon,
  building: Building,
  basketBall: BasketBall,
  nixEighteen: NixEighteen,
  zoo: Zoo,
  beerTag: BeerTag,
  eighteenPlus,
  alertInfo: AlertInfoIcon,
  settings: SettingsIcon,
  expand_arrow: ExpandArrowIcon,
  canvas: Canvas,
  expand_screen: ExpandScreenIcon,
  expand_diagonal: ExpandDiagonalIcon,
  edit: EditIcon,
  trashCircle: TrashCircleIcon,
  pencilSquare: PencilSquareIcon,
  earMarkFill: EarMarkFillIcon,
  draft: DraftIcon,
  email: EmailIcon,
  download: DownloadIcon,
  attachment: AttachmentIcon,
  diagonalArrow: DiagonalArrowIcon,
} as const;

export type IconName = keyof typeof icons;
